import { render, staticRenderFns } from "./adjust-notice-of-need.vue?vue&type=template&id=c9cd48ae"
import script from "./adjust-notice-of-need.vue?vue&type=script&lang=js"
export * from "./adjust-notice-of-need.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports